import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SEO from '@/components/SEO';

export default function PrivacyPage() {
  return (
    <div data-testid="privacy-page">
      <SEO title="Privacy Policy" description="Go Freestyle Studios privacy policy." path="/privacy" noindex />
      <section className="py-16 sm:py-24">
        <div className="max-w-2xl mx-auto px-4 sm:px-8">
          <h1 className="font-heading text-3xl sm:text-4xl font-medium text-[#1A1A1A] tracking-tight mb-6">
            Privacy Policy
          </h1>
          <div className="bg-[#FAF9F6] rounded-2xl p-6 sm:p-8 border border-[#E5E2DC]" data-testid="privacy-notice">
            <p className="text-base text-[#5C5C55] leading-relaxed mb-4">
              Our privacy policy is being finalised and will be published here shortly.
            </p>
            <p className="text-sm text-[#8A8B85] leading-relaxed">
              If you have any questions about how we handle your data, please contact us at{' '}
              <a href="mailto:hello@gofreestyle.co.uk" className="text-[#3A4035] underline underline-offset-2 hover:text-[#2B3027] transition-colors">hello@gofreestyle.co.uk</a>.
            </p>
          </div>
          <div className="mt-8">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#5C5C55] hover:text-[#3A4035] transition-colors">
              <ArrowRight className="w-4 h-4 rotate-180" strokeWidth={1.5} /> Back to home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
